"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardFragmentFailedEvent = exports.WizardFragmentCreatedEvent = exports.WizardPlanAssignedEvent = exports.WizardReviewReplicaSetCancelledEvent = exports.WizardReviewReplicaSetFailedEvent = exports.WizardReviewReplicaSetCompletedEvent = exports.WizardReviewLifecycleFailedEvent = exports.WizardReviewCancelledEvent = exports.WizardReviewFailedEvent = exports.WizardReviewCompletedEvent = exports.WizardReviewCreatedEvent = exports.WizardReviewReplicaSetCreatedEvent = exports.WizardPlanCancelledEvent = exports.planCancellationReasonSchema = exports.PlanCancellationReason = exports.WizardPlanDiscardedEvent = exports.WizardPlanCompletedEvent = exports.WizardStepAvailableEvent = exports.WizardPlanCreatedEvent = exports.WizardFragmentCancelledEvent = exports.WizardFragmentCompletedEvent = exports.WizardClaimReleasedEvent = exports.WizardClaimExpiredEvent = exports.WizardClaimProlongedEvent = exports.WizardStepAbortedEvent = exports.WizardStepSubmittedEvent = exports.WizardStepReopenedEvent = exports.WizardStepClaimedEvent = exports.FragmentFailureCauses = void 0;
const zod_1 = require("zod");
const event_1 = require("../event");
exports.FragmentFailureCauses = ['operatorAbort', 'finalizerError', 'rollup'];
exports.WizardStepClaimedEvent = (0, event_1.createEventClass)('WizardStepClaimedEvent', zod_1.z.object({
    userId: zod_1.z.string(),
    planId: zod_1.z.string(),
    stepId: zod_1.z.string(),
    stepType: zod_1.z.string(),
    fragmentId: zod_1.z.string(),
    packageId: zod_1.z.string().optional(),
    orgId: zod_1.z.string().optional(),
    generatorName: zod_1.z.string().optional(),
    isTraineeMode: zod_1.z.boolean(),
    assignedUserPoolId: zod_1.z.string().nullable().optional(),
    priorityBucket: zod_1.z.string().optional(),
}));
exports.WizardStepReopenedEvent = (0, event_1.createEventClass)('WizardStepReopenedEvent', zod_1.z.object({
    userId: zod_1.z.string(),
    planId: zod_1.z.string(),
    stepId: zod_1.z.string(),
    fragmentId: zod_1.z.string(),
    packageId: zod_1.z.string().optional(),
    orgId: zod_1.z.string().optional(),
    generatorName: zod_1.z.string().optional(),
    reopenedStepIds: zod_1.z.array(zod_1.z.string()),
    isTraineeMode: zod_1.z.boolean(),
}));
exports.WizardStepSubmittedEvent = (0, event_1.createEventClass)('WizardStepSubmittedEvent', zod_1.z.object({
    userId: zod_1.z.string(),
    planId: zod_1.z.string(),
    stepId: zod_1.z.string(),
    stepType: zod_1.z.string(),
    fragmentId: zod_1.z.string(),
    packageId: zod_1.z.string().optional(),
    orgId: zod_1.z.string().optional(),
    generatorName: zod_1.z.string().optional(),
    durationMs: zod_1.z.number().optional(),
    isTraineeMode: zod_1.z.boolean(),
    assignedUserPoolId: zod_1.z.string().nullable().optional(),
    priorityBucket: zod_1.z.string().optional(),
}));
exports.WizardStepAbortedEvent = (0, event_1.createEventClass)('WizardStepAbortedEvent', zod_1.z.object({
    userId: zod_1.z.string(),
    planId: zod_1.z.string(),
    stepId: zod_1.z.string(),
    stepType: zod_1.z.string(),
    fragmentId: zod_1.z.string().optional(),
    packageId: zod_1.z.string().optional(),
    orgId: zod_1.z.string().optional(),
    generatorName: zod_1.z.string().optional(),
    reason: zod_1.z.string(),
    isFailureAbort: zod_1.z.boolean(),
    isTraineeMode: zod_1.z.boolean(),
    assignedUserPoolId: zod_1.z.string().nullable().optional(),
    priorityBucket: zod_1.z.string().optional(),
}));
exports.WizardClaimProlongedEvent = (0, event_1.createEventClass)('WizardClaimProlongedEvent', zod_1.z.object({
    userId: zod_1.z.string(),
    planId: zod_1.z.string(),
    fragmentId: zod_1.z.string(),
    stepId: zod_1.z.string(),
}));
exports.WizardClaimExpiredEvent = (0, event_1.createEventClass)('WizardClaimExpiredEvent', zod_1.z.object({
    userId: zod_1.z.string(),
    planId: zod_1.z.string(),
    fragmentId: zod_1.z.string(),
    stepId: zod_1.z.string(),
    expiredAt: zod_1.z.string(),
}));
exports.WizardClaimReleasedEvent = (0, event_1.createEventClass)('WizardClaimReleasedEvent', zod_1.z.object({
    userId: zod_1.z.string(),
    planId: zod_1.z.string(),
    fragmentId: zod_1.z.string(),
    stepId: zod_1.z.string(),
}));
exports.WizardFragmentCompletedEvent = (0, event_1.createEventClass)('WizardFragmentCompletedEvent', zod_1.z.object({
    userId: zod_1.z.string(),
    planId: zod_1.z.string(),
    fragmentId: zod_1.z.string(),
    generatorName: zod_1.z.string(),
    packageId: zod_1.z.string().optional(),
    orgId: zod_1.z.string().optional(),
    isTraineeMode: zod_1.z.boolean(),
    generatorId: zod_1.z.string().optional(),
    assignedUserPoolId: zod_1.z.string().nullable().optional(),
    durationMs: zod_1.z.number().optional(),
}));
exports.WizardFragmentCancelledEvent = (0, event_1.createEventClass)('WizardFragmentCancelledEvent', zod_1.z.object({
    planId: zod_1.z.string(),
    fragmentId: zod_1.z.string(),
    fragmentName: zod_1.z.string(),
    reason: zod_1.z.string(),
    cancelledStepCount: zod_1.z.number(),
    generatorId: zod_1.z.string().optional(),
    generatorName: zod_1.z.string().optional(),
    assignedUserPoolId: zod_1.z.string().nullable().optional(),
    packageId: zod_1.z.string().optional(),
    isTraineeMode: zod_1.z.boolean().optional(),
}));
exports.WizardPlanCreatedEvent = (0, event_1.createEventClass)('WizardPlanCreatedEvent', zod_1.z.object({
    planId: zod_1.z.string(),
    generatorName: zod_1.z.string(),
    stepCount: zod_1.z.number(),
    assignedToOrgId: zod_1.z.string().nullable(),
    assignedToUserId: zod_1.z.string().nullable(),
    packageId: zod_1.z.string().optional(),
    isTraineeMode: zod_1.z.boolean(),
    spawnPurpose: zod_1.z.string().optional(),
    inferredSigmaModelType: zod_1.z.string().optional(),
}));
exports.WizardStepAvailableEvent = (0, event_1.createEventClass)('WizardStepAvailableEvent', zod_1.z.object({
    stepId: zod_1.z.string(),
    planId: zod_1.z.string(),
    stepType: zod_1.z.string(),
    fragmentId: zod_1.z.string().optional(),
    packageId: zod_1.z.string().optional(),
    orgId: zod_1.z.string().optional(),
    generatorName: zod_1.z.string().optional(),
    isTraineeMode: zod_1.z.boolean(),
    assignedUserPoolId: zod_1.z.string().nullable().optional(),
    priorityBucket: zod_1.z.string().optional(),
}));
exports.WizardPlanCompletedEvent = (0, event_1.createEventClass)('WizardPlanCompletedEvent', zod_1.z.object({
    planId: zod_1.z.string(),
    generatorName: zod_1.z.string().optional(),
    packageId: zod_1.z.string().optional(),
    orgId: zod_1.z.string().optional(),
    totalDurationMs: zod_1.z.number().optional(),
    stepCount: zod_1.z.number(),
    fragmentCount: zod_1.z.number(),
    userId: zod_1.z.string(),
    isTraineeMode: zod_1.z.boolean(),
}));
exports.WizardPlanDiscardedEvent = (0, event_1.createEventClass)('WizardPlanDiscardedEvent', zod_1.z.object({
    planId: zod_1.z.string(),
    packageId: zod_1.z.string(),
    reason: zod_1.z.enum(['staleResolution', 'packagePublished']),
    planCreatedAtMs: zod_1.z.number(),
    latestResolutionAtMs: zod_1.z.number().optional(),
    generatorName: zod_1.z.string().optional(),
    orgId: zod_1.z.string().optional(),
    userId: zod_1.z.string().optional(),
}));
var PlanCancellationReason;
(function (PlanCancellationReason) {
    PlanCancellationReason["AdminCancel"] = "adminCancel";
    PlanCancellationReason["ReviewerCancel"] = "reviewerCancel";
    PlanCancellationReason["StepFailure"] = "stepFailure";
    PlanCancellationReason["Prune"] = "prune";
})(PlanCancellationReason || (exports.PlanCancellationReason = PlanCancellationReason = {}));
exports.planCancellationReasonSchema = zod_1.z.nativeEnum(PlanCancellationReason);
exports.WizardPlanCancelledEvent = (0, event_1.createEventClass)('WizardPlanCancelledEvent', zod_1.z.object({
    planId: zod_1.z.string(),
    generatorName: zod_1.z.string().optional(),
    packageId: zod_1.z.string().optional(),
    orgId: zod_1.z.string().optional(),
    cancellationReason: exports.planCancellationReasonSchema,
    triggeredByUserId: zod_1.z.string().optional(),
    note: zod_1.z.string().optional(),
    isTraineeMode: zod_1.z.boolean(),
}));
exports.WizardReviewReplicaSetCreatedEvent = (0, event_1.createEventClass)('WizardReviewReplicaSetCreatedEvent', zod_1.z.object({
    planId: zod_1.z.string(),
    replicaSetId: zod_1.z.string(),
    packageId: zod_1.z.string().optional(),
    reviewCount: zod_1.z.number(),
    manufacturerPartNumber: zod_1.z.string().optional(),
    sigmaModelType: zod_1.z.string().optional(),
    pinCount: zod_1.z.number().int().optional(),
}));
exports.WizardReviewCreatedEvent = (0, event_1.createEventClass)('WizardReviewCreatedEvent', zod_1.z.object({
    planId: zod_1.z.string(),
    reviewId: zod_1.z.string(),
    ref: zod_1.z.string(),
    packageId: zod_1.z.string().optional(),
    manufacturerPartNumber: zod_1.z.string().optional(),
    sigmaModelType: zod_1.z.string().optional(),
    pinCount: zod_1.z.number().int().optional(),
}));
const reviewTerminalFields = {
    planId: zod_1.z.string(),
    reviewId: zod_1.z.string(),
    ref: zod_1.z.string(),
    packageId: zod_1.z.string().optional(),
    generatorName: zod_1.z.string(),
    isTraineeMode: zod_1.z.boolean(),
    durationMs: zod_1.z.number().optional(),
    completedByUserIds: zod_1.z.array(zod_1.z.string()),
    didWriteToPackageStore: zod_1.z.boolean(),
    blobPath: zod_1.z.string().nullable(),
    manufacturerPartNumber: zod_1.z.string().optional(),
    sigmaModelType: zod_1.z.string().optional(),
    pinCount: zod_1.z.number().int().optional(),
};
exports.WizardReviewCompletedEvent = (0, event_1.createEventClass)('WizardReviewCompletedEvent', zod_1.z.object(reviewTerminalFields));
exports.WizardReviewFailedEvent = (0, event_1.createEventClass)('WizardReviewFailedEvent', zod_1.z.object(reviewTerminalFields));
exports.WizardReviewCancelledEvent = (0, event_1.createEventClass)('WizardReviewCancelledEvent', zod_1.z.object(reviewTerminalFields));
exports.WizardReviewLifecycleFailedEvent = (0, event_1.createEventClass)('WizardReviewLifecycleFailedEvent', zod_1.z.object({
    planId: zod_1.z.string(),
    packageId: zod_1.z.string().optional(),
    phase: zod_1.z.enum(['creation', 'rollup']),
    error: zod_1.z.string(),
}));
const replicaSetTerminalFields = {
    planId: zod_1.z.string(),
    replicaSetId: zod_1.z.string(),
    packageId: zod_1.z.string().optional(),
    generatorName: zod_1.z.string(),
    isTraineeMode: zod_1.z.boolean(),
    durationMs: zod_1.z.number().optional(),
    reviewCount: zod_1.z.number(),
    manufacturerPartNumber: zod_1.z.string().optional(),
    sigmaModelType: zod_1.z.string().optional(),
    pinCount: zod_1.z.number().int().optional(),
};
exports.WizardReviewReplicaSetCompletedEvent = (0, event_1.createEventClass)('WizardReviewReplicaSetCompletedEvent', zod_1.z.object(replicaSetTerminalFields));
exports.WizardReviewReplicaSetFailedEvent = (0, event_1.createEventClass)('WizardReviewReplicaSetFailedEvent', zod_1.z.object(replicaSetTerminalFields));
exports.WizardReviewReplicaSetCancelledEvent = (0, event_1.createEventClass)('WizardReviewReplicaSetCancelledEvent', zod_1.z.object(replicaSetTerminalFields));
exports.WizardPlanAssignedEvent = (0, event_1.createEventClass)('WizardPlanAssignedEvent', zod_1.z.object({
    planId: zod_1.z.string(),
    generatorName: zod_1.z.string().optional(),
    packageId: zod_1.z.string().optional(),
    previousOrgId: zod_1.z.string().nullable(),
    previousUserId: zod_1.z.string().nullable(),
    assignedToOrgId: zod_1.z.string().nullable(),
    assignedToUserId: zod_1.z.string().nullable(),
    isTraineeMode: zod_1.z.boolean(),
}));
exports.WizardFragmentCreatedEvent = (0, event_1.createEventClass)('WizardFragmentCreatedEvent', zod_1.z.object({
    planId: zod_1.z.string(),
    fragmentId: zod_1.z.string(),
    generatorId: zod_1.z.string(),
    generatorName: zod_1.z.string(),
    assignedUserPoolId: zod_1.z.string().nullable(),
    packageId: zod_1.z.string().optional(),
    priorityBucket: zod_1.z.string().optional(),
    isTraineeMode: zod_1.z.boolean(),
}));
exports.WizardFragmentFailedEvent = (0, event_1.createEventClass)('WizardFragmentFailedEvent', zod_1.z.object({
    planId: zod_1.z.string(),
    fragmentId: zod_1.z.string(),
    generatorId: zod_1.z.string(),
    generatorName: zod_1.z.string().optional(),
    completedByUserId: zod_1.z.string().nullable(),
    assignedUserPoolId: zod_1.z.string().nullable(),
    packageId: zod_1.z.string().optional(),
    failureCause: zod_1.z.enum(exports.FragmentFailureCauses),
    failureReason: zod_1.z.string().optional(),
    note: zod_1.z.string().optional(),
    isTraineeMode: zod_1.z.boolean(),
}));
//# sourceMappingURL=wizard-events.js.map